var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMt5Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.984,
    height: 12.479,
    viewBox: "0 0 9.984 12.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1982",
    "data-name": "Group 1982",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M13.736,18.744V17.5a2.5,2.5,0,0,0-2.5-2.5H7.5A2.5,2.5,0,0,0,5,17.5v1.248Z",
    transform: "translate(-0.376 -4.888)",
    fill: "#ffd00e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048_-_Outline",
    "data-name": "Path 1048 - Outline",
    d: "M13.36,18.992H4.624A.624.624,0,0,1,4,18.368V17.12A3.123,3.123,0,0,1,7.12,14h3.744a3.123,3.123,0,0,1,3.12,3.12v1.248A.624.624,0,0,1,13.36,18.992ZM5.248,17.744h7.488V17.12a1.874,1.874,0,0,0-1.872-1.872H7.12A1.874,1.874,0,0,0,5.248,17.12Z",
    transform: "translate(0 -4.512)",
    fill: "#ac8c25"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_130",
    "data-name": "Ellipse 130",
    cx: 2.159,
    cy: 2.698,
    rx: 2.159,
    ry: 2.698,
    transform: "translate(6.842 2.843)",
    fill: "#ffd00e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_130_-_Outline",
    "data-name": "Ellipse 130 - Outline",
    d: "M2.12-1A3.12,3.12,0,1,1-1,2.12,3.123,3.123,0,0,1,2.12-1Zm0,4.992A1.872,1.872,0,1,0,.248,2.12,1.874,1.874,0,0,0,2.12,3.992Z",
    transform: "translate(6.872 3)",
    fill: "#ac8c25"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt5Icon);
export default __webpack_public_path__ + "static/media/mt5icon.60188d62c34c0b430179a956e9e24fe5.svg";
export { ForwardRef as ReactComponent };